export default function WhatsIsTtm() {
  return (
    <div
      className="py-20 bg-white"
      style={{
        background: "url(./images/our-corporate-grid.svg)",
        backgroundPosition: "center",
      }}
    >
      <div className="container mx-auto px-4">
        <div className="mb-6 text-center">
          <h2 className="text-7xl ">
            What is{" "}
            <strong className="text-indigo-500 font-bold from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
              TTM
            </strong>
            ?
          </h2>
        </div>
        <div className="mb-8 text-center text-xl m-auto max-w-[900px]">
          <p>
            We are{" "}
            <strong className="font-bold from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
              USA's most trusted Transport Solutions
            </strong>{" "}
            brand that gives an access to a fleet Managment, GPS Vehicle
            Tracking, and active Drivers in the{" "}
            <strong className="font-bold from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
              own terminals.
            </strong>
          </p>
        </div>
        <div className="flex justify-center">
          <div className="w-full lg:w-10/12">
            <div className="flex flex-wrap -mx-2">
              <div className="w-1/3 px-2 mb-4">
                <div className="flex flex-col items-center p-4 text-center">
                  <div className="mb-2">
                    <div className="border border-[3px] border-indigo-500 rounded-full h-[100px] w-[100px] items-center justify-center flex">
                      <i className="fa-solid fa-robot  text-gray-700 text-5xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-medium from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
                      <span className="counter">AI</span>
                    </h3>
                    <p className="text-gray-600">Load Build</p>
                  </div>
                </div>
              </div>
              <div className="w-1/3 px-2 mb-4">
                <div className="flex flex-col items-center p-4 text-center">
                  <div className="mb-2">
                    <div className="border border-[3px] border-indigo-500 rounded-full h-[100px] w-[100px] items-center justify-center flex">
                      <i className="fa-solid fa-truck  text-gray-700 text-5xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-medium from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
                      Fleet
                    </h3>
                    <p className="text-gray-600">Optimization</p>
                  </div>
                </div>
              </div>
              <div className="w-1/3 px-2 mb-4">
                <div className="flex flex-col items-center p-4 text-center">
                  <div className="mb-2">
                    <div className="border border-[3px] border-indigo-500 rounded-full h-[100px] w-[100px] items-center justify-center flex">
                      <i className="fa-solid fa-box  text-gray-700 text-5xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-medium from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
                      <span className="counter">Load</span>
                    </h3>
                    <p className="text-gray-600">Tracking</p>
                  </div>
                </div>
              </div>
              <div className="w-1/3 px-2 mb-4">
                <div className="flex flex-col items-center p-4 text-center">
                  <div className="mb-2">
                    <div className="border border-[3px] border-indigo-500 rounded-full h-[100px] w-[100px] items-center justify-center flex">
                      <i className="fa-solid fa-gears  text-gray-700 text-5xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-medium from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
                      <span className="counter">Automated</span>
                    </h3>
                    <p className="text-gray-600">Invoicing</p>
                  </div>
                </div>
              </div>
              <div className="w-1/3 px-2 mb-4">
                <div className="flex flex-col items-center p-4 text-center">
                  <div className="mb-2">
                    <div className="border border-[3px] border-indigo-500 rounded-full h-[100px] w-[100px] items-center justify-center flex">
                      <i className="fa-solid fa-van-shuttle  text-gray-700 text-5xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-medium from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
                      Vehicle
                    </h3>
                    <p className="text-gray-600">Reports</p>
                  </div>
                </div>
              </div>
              <div className="w-1/3 px-2 mb-4">
                <div className="flex flex-col items-center p-4 text-center">
                  <div className="mb-2">
                    <div className="border border-[3px] border-indigo-500 rounded-full h-[100px] w-[100px] items-center justify-center flex">
                      <i className="fa-solid fa-trailer text-gray-700 text-5xl"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-medium from-[#a200be] to-[#246BFD] bg-gradient-to-tl font-bold bg-clip-text text-transparent">
                      <span className="counter">Trailer</span>
                    </h3>
                    <p className="text-gray-600">Reports</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
